import { defineMessages, useIntl } from "react-intl";

import type { TravellerType } from "@/features/trips/types/types";

const labelMap = defineMessages({
  adultInDoubleRoom: {
    id: "trips.travellersSelection.adultInDoubleRoom.title",
    defaultMessage: "Adult in double room",
  },
  adultInSingleRoom: {
    id: "trips.travellersSelection.adultInSingleRoom.title",
    defaultMessage: "Adult in single room",
  },
  childWithBed: {
    id: "trips.travellersSelection.childWithBed.title",
    defaultMessage: "Child with bed",
  },
  childWithoutBed: {
    id: "trips.travellersSelection.childWithoutBed.title",
    defaultMessage: "Child without bed",
  },
  infant: {
    id: "trips.travellersSelection.infant.title",
    defaultMessage: "Infant",
  },
});

type Props = {
  rooms: Record<TravellerType, number>;
};

export function RoomList({ rooms }: Props) {
  const intl = useIntl();

  return (
    <ul className="space-y-1 text-sm font-medium text-text-primary">
      {Object.entries(rooms).map(([travellerType, count]) => {
        if (count === 0) return null;

        return (
          <li key={travellerType} className="text-sm">
            {count}x{" "}
            {intl.formatMessage(labelMap[travellerType as TravellerType])}
          </li>
        );
      })}
    </ul>
  );
}
